module.exports = __webpack_public_path__ + "img/Chile.74848ac2.png";